import { Shippings, Service } from '../../type'
import { Delivery } from '../Delivery'
import { PickUpInStore } from '../PickUpInStore'

const ProductList = ({ shippings, services }: { shippings: Shippings, services: Service[] }) => (
  <>
    {shippings.map((shipping, index) => {
      switch (shipping.type) {
        case 'delivery':
          return <Delivery key={index} shipping={shipping} services={services}/>
        case 'pickUpInStore':
          return <PickUpInStore key={index} shipping={shipping} services={services}/>
      }
    })}
  </>
)

export default ProductList
